import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FeedErrorProps {
  error: Error | null;
  onRetry: () => void;
}

export function FeedError({ error, onRetry }: FeedErrorProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-md border bg-card py-12">
      <div className="flex flex-col items-center gap-2 text-muted-foreground">
        <AlertTriangle className="h-12 w-12 text-destructive" />
        <h3 className="text-lg font-semibold text-foreground">
          {error?.message ?? "Failed to load feed"}
        </h3>
        <p className="text-sm">
          {error?.message === "Failed to fetch social posts"
            ? "Please check your connection and try again"
            : (error?.message ?? "Something went wrong while loading the social feed")}
        </p>
      </div>
      <Button onClick={onRetry} className="mt-4">
        Try Again
      </Button>
    </div>
  );
}
